import { UndoOutlined } from '@ant-design/icons';
import { Button, Popconfirm } from 'antd';
import { PopconfirmProps } from 'antd/lib';

export const UndoAction = ({ onConfirm }: Omit<PopconfirmProps, 'title'>) => (
  <Popconfirm
    title='Sure to undo?'
    onConfirm={onConfirm}
  >
    <Button
      type='text'
      size='small'
      className='mr-1'
      icon={<UndoOutlined title='Undo' className='text-[#faad14]' />}
    />
  </Popconfirm>
);
